<!-- =========================================================================================
  File Name: Staff.vue
  Description: Nursing Home Staff List
========================================================================================== -->
<template>
	<div id="StaffMembers">
		<vs-row class="top-row">
			<vs-col vs-offset="8" vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
				<vs-button @click="viewAddUserdialog()" class="add-btn-top" color="primary" type="gradient" icon="library_add">Add User To Nursing Home</vs-button>
			</vs-col>
			<!-- dialog box for adding new user to nusrsing home  -->
			<vs-prompt
				color="success"
				class="centerx nh-add-usr-popup nh-add-nursing-home"
				title="Add New User"
				acceptText="Add"
				@accept="addNewUser"
				:active.sync="activeAddView">
				<div class="con-exemple-prompt vx-row">
					<div class="vx-col w-1/2 centerx labelx">
						<vs-input v-validate="'required|alpha_spaces'" label="First Name" name="u_first_name" v-model="u_first_name"/>
						<span class="text-danger text-sm" v-show="errors.has('u_first_name')">{{ errors.first('u_first_name') }}</span>
					</div>
					<div class="vx-col w-1/2 centerx labelx">
						<vs-input v-validate="'required|alpha_spaces'" label="Last Name" name="u_last_name" v-model="u_last_name"/>
						<span class="text-danger text-sm" v-show="errors.has('u_last_name')">{{ errors.first('u_last_name') }}</span>
					</div>							
					<div class="vx-col w-full centerx labelx">
						<vs-input type="email" v-validate="'required|email'" label="Email" name="u_email" v-model="u_email"/>
						<span class="text-danger text-sm" v-show="errors.has('u_email')">{{ errors.first('u_email') }}</span>
					</div>
					
					<div class="vx-col w-1/2 centerx labelx">
						<vs-input type="password" v-validate="'required'" label="Password" name="u_password"  v-model="u_password"/>
						<span class="text-danger text-sm" v-show="errors.has('u_password')">{{ errors.first('u_password') }}</span>
					</div>
					<div class="vx-col w-1/2 centerx labelx">
						<vs-input type="text" v-validate="'required|numeric|min:10|max:10'" label="Phone" name="u_phone" v-model="u_phone"/>
						<span class="text-danger text-sm" v-show="errors.has('u_phone')">{{ errors.first('u_phone') }}</span>
					</div>			
					<div class="vx-col w-full centerx labelx select-user-role mt-5">		
						<!-- <vs-select class="select-user-role" v-validate="'required'" label="Role" name="u_role" v-model="u_role">
							<vs-select-item :key="index" :value="roles.id" :text="roles.designationName" v-for="(roles,index) in designations" />
         			 	</vs-select> -->
						
						<label for="" class="vs-input--label">Role</label>
						<v-select v-validate="'required'" name="u_role" v-model="u_role" :options="designations" />
 
						<span class="text-danger text-sm" v-show="errors.has('u_role')">{{ errors.first('u_role') }}</span>
					</div>
				</div>
			</vs-prompt>		
		</vs-row>		
		
		<vs-row>
			<vs-tabs alignment="fixed" class="nh-usr-tabs">
				<vs-tab label="Nursing Home Admins">
					<div>
						<div v-for="member in staffMembers" v-if="member.user_permissions.isNursingHomeAdmin == 1"  class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base profile-card">
							<vx-card class="p-2 nh-usr-cards">
								<vs-avatar class="mx-auto mb-6 block" size="80px" />
								<div class="text-center">
									<h4>{{ member.firstName }} {{ member.lastName }}</h4>
									<p class="text-grey">{{ formatUserPermissions(member.user_permissions) }}</p>
								</div>
								<div class="flex justify-between flex-wrap">
									<vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="rgba(var(--vs-primary), 1)" gradient-color-secondary="rgba(var(--vs-primary), 1)" @click="viewUserDetails(member)">Edit</vs-button>
									<vs-button v-if="member.isActive == 1" class="mt-4" type="border" color="#b9b9b9" @click="confirmDeletion(member.custID)">Deactivate</vs-button>
									<vs-button v-else class="mt-4" type="border" color="#b9b9b9" @click="confirmActivation(member.custID)">Activate</vs-button>
								</div>
								<template slot="footer">
									<vs-divider />
									<div class="flex justify-between">
										<span class="flex items-center">
											<feather-icon icon="MailIcon" svgClasses="h-5 w-5 text-warning stroke-current" />
											<span class="ml-2">{{ member.email }}</span>
										</span>
									</div>
									<div class="flex justify-between">
										<span class="flex items-center">
											<feather-icon icon="PhoneIcon" svgClasses="h-5 w-5 text-primary stroke-current" />
											<span class="ml-2">{{ member.phone }}</span>
										</span>
									</div>
									<div class="flex justify-between">
										<span v-if="member.isActive == 1" class="flex items-center">
											<feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 text-success stroke-current" />
											<span class="ml-2" >Active</span>
										</span>
										<span v-else class="flex items-center">
											<feather-icon icon="MinusCircleIcon" svgClasses="h-5 w-5 text-danger stroke-current" />
											<span class="ml-2" >Not Active</span>
										</span>
									</div>
								</template>
							</vx-card>
						</div>					
					</div>					
				</vs-tab>
				<vs-tab label="Staff Members">
					<div>
						<div v-for="member in staffMembers" v-if="member.user_permissions.isStaff == 1" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base profile-card">
							<vx-card class="p-2 nh-usr-cards">
								<vs-avatar class="mx-auto mb-6 block" size="80px" />
								<div class="text-center">
									<h4>{{ member.firstName }} {{ member.lastName }}</h4>
									<p class="text-grey">{{ formatUserPermissions(member.user_permissions) }}</p>
								</div>
								<div class="flex justify-between flex-wrap">
									<vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="rgba(var(--vs-primary), 1)" gradient-color-secondary="rgba(var(--vs-primary), 1)" @click="viewUserDetails(member)">Edit</vs-button>
									<vs-button v-if="member.isActive == 1" class="mt-4" type="border" color="#b9b9b9" @click="confirmDeletion(member.custID)">Deactivate</vs-button>
									<vs-button v-else class="mt-4" type="border" color="#b9b9b9" @click="confirmActivation(member.custID)">Activate</vs-button>
								</div>
								<template slot="footer">
									<vs-divider />
									<div class="flex justify-between">
										<span class="flex items-center">
											<feather-icon icon="MailIcon" svgClasses="h-5 w-5 text-warning stroke-current" />
											<span class="ml-2">{{ member.email }}</span>
										</span>
									</div>
									<div class="flex justify-between">
										<span class="flex items-center">
											<feather-icon icon="PhoneIcon" svgClasses="h-5 w-5 text-primary stroke-current" />
											<span class="ml-2">{{ member.phone }}</span>
										</span>
									</div>
									<div class="flex justify-between">
										<span v-if="member.isActive == 1" class="flex items-center">
											<feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 text-success stroke-current" />
											<span class="ml-2" >Active</span>
										</span>
										<span v-else class="flex items-center">
											<feather-icon icon="MinusCircleIcon" svgClasses="h-5 w-5 text-danger stroke-current" />
											<span class="ml-2" >Not Active</span>
										</span>
									</div>
								</template>
							</vx-card>
						</div>					
					</div>	
				</vs-tab>
				<vs-tab label="Customers">
					<div>
						<div v-for="member in staffMembers" v-if="member.user_permissions.isUser == 1" class="vx-col w-full sm:w-1/2 lg:w-1/3 mb-base profile-card">
							<vx-card class="p-2 nh-usr-cards">
								<vs-avatar class="mx-auto mb-6 block" size="80px" />
								<div class="text-center">
									<h4>{{ member.firstName }} {{ member.lastName }}</h4>
									<p class="text-grey">{{ formatUserPermissions(member.user_permissions) }}</p>
								</div>
								<div class="flex justify-between flex-wrap">
									<vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="rgba(var(--vs-primary), 1)" gradient-color-secondary="rgba(var(--vs-primary), 1)" @click="viewUserDetails(member)">Edit</vs-button>
									<vs-button v-if="member.isActive == 1" class="mt-4" type="border" color="#b9b9b9" @click="confirmDeletion(member.custID)">Deactivate</vs-button>
									<vs-button v-else class="mt-4" type="border" color="#b9b9b9" @click="confirmActivation(member.custID)">Activate</vs-button>
								</div>
								<template slot="footer">
									<vs-divider />
									<div class="flex justify-between">
										<span class="flex items-center">
											<feather-icon icon="MailIcon" svgClasses="h-5 w-5 text-warning stroke-current" />
											<span class="ml-2">{{ member.email }}</span>
										</span>
									</div>
									<div class="flex justify-between">
										<span class="flex items-center">
											<feather-icon icon="PhoneIcon" svgClasses="h-5 w-5 text-primary stroke-current" />
											<span class="ml-2">{{ member.phone }}</span>
										</span>
									</div>
									<div class="flex justify-between">
										<span v-if="member.isActive == 1" class="flex items-center">
											<feather-icon icon="CheckCircleIcon" svgClasses="h-5 w-5 text-success stroke-current" />
											<span class="ml-2" >Active</span>
										</span>
										<span v-else class="flex items-center">
											<feather-icon icon="MinusCircleIcon" svgClasses="h-5 w-5 text-danger stroke-current" />
											<span class="ml-2" >Not Active</span>
										</span>
									</div>									
								</template>
							</vx-card>
						</div>					
					</div>	
				</vs-tab>
			</vs-tabs>

		</vs-row>
		
		
		<vs-row vs-justify="left">
			<!-- Dialog box for viewing user details  -->
			<vs-prompt
				color="danger"
				class="centerx nh-edit-usr-dt"
				title="Edit User Details"
				acceptText="Save"
				@accept="updateUserInfo"
				:active.sync="activeDetailView">
				<div class="con-exemple-prompt vx-row">
					<div class="vx-col w-1/2 centerx labelx">
						<vs-input v-validate="'required|alpha_spaces'" label="First Name" name="up_first_name" v-model="up_first_name"/>
						<span class="text-danger text-sm" v-show="errors.has('up_first_name')">{{ errors.first('up_first_name') }}</span>
					</div>
					<div class="vx-col w-1/2 centerx labelx">
						<vs-input v-validate="'required|alpha_spaces'" label="Last Name" name="up_last_name" v-model="up_last_name"/>
						<span class="text-danger text-sm" v-show="errors.has('up_last_name')">{{ errors.first('up_last_name') }}</span>
					</div>	
					<!-- <div class="centerx labelx">
						<vs-input type="email" class="w-100" label="Email" v-model="up_email"/>
					</div>
					
					<div class="centerx labelx">
						<vs-input type="password" class="w-50"  label="Password" v-model="up_password"/>
						<vs-input class="w-50"  label="Phone" v-model="up_phone"/>
					</div> -->
					<div class="vx-col w-full centerx labelx select-user-role mt-5">		
						<!-- <vs-select class="select-user-role" v-validate="'required'" label="Role" name="up_role" v-model="up_role">
							<vs-select-item :key="index" :value="roles.id" :text="roles.designationName" v-for="(roles,index) in designations" />
         			 	</vs-select> -->
						
						<label for="" class="vs-input--label">Role</label>
						<v-select v-validate="'required'" name="up_role" v-model="up_role" :options="designations" />
 
						<span class="text-danger text-sm" v-show="errors.has('up_role')">{{ errors.first('up_role') }}</span>
					</div>
				</div>
			</vs-prompt>			

		</vs-row>
	</div>
</template>
<script>
// For custom error message
import { Validator } from 'vee-validate'
import vSelect from 'vue-select'
const dict = {
  custom: {
    u_first_name: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    u_last_name: {
	  required: 'Field is required',
	  alpha_spaces: 'Invalid value'
    },
    u_email: {
      required: 'Field is required',
      email: 'Invalid Email'
    },
    u_password: {
      required: 'Field is required'
    },
    u_phone: {
      required: 'Field is required',
      numeric: 'Invalid phone',
      min: 'Invalid phone',
      max: 'Invalid phone'
    },
    u_role: {
      required: 'Field is required'
    },
	
    up_first_name: {
      required: 'Field is required',
      alpha_spaces: 'Invalid value'
    },
    up_last_name: {
	  required: 'Field is required',
	  alpha_spaces: 'Invalid value'
    }, 
    up_role: {
      required: 'Field is required'
    }

  }
}

// register custom messages
Validator.localize('en', dict)
export default{
  components: {
   		 'v-select': vSelect
 	 },	
  data () {
	  return {
      publicPath: process.env.BASE_URL,
      nursingHomeID: this.$route.params.nhID,
      staffMembers: [],
      designations: [],
      // for adding new user
      activeAddView: false,
      u_first_name: '',
      u_last_name: '',
      u_email: '',
      u_password: '',
      u_phone: '',
      u_role: '',
      errorList: [],

      // for editing user info
      activeDetailView: false,
      up_first_name: '',
      up_last_name: '',
      //up_email: "",
      //up_password: "",
      up_phone: '',
      up_role: '',
      up_custID: ''		
	  }
  },
  methods: {
    staffList () {
      this.$vs.loading()
      const formData = new FormData()
      formData.append('nusingHomeID', this.nursingHomeID)
      this.$http.post('/list-nursing-home-users/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
        .then((response) => {
          if (response.data.messageType == 'success') {
            this.staffMembers = JSON.parse(JSON.stringify(response.data.data))
            this.$vs.loading.close()
            return this.staffMembers
          } else {
            this.$vs.loading.close()
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.staffMembers
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.staffMembers
        })
    },
    designationList () {
      this.$vs.loading()
      this.$http.get('/designations/')
        .then((response) => {
          if (response.data.messageType == 'success') {
            const formatted_desg = JSON.parse(JSON.stringify(response.data.data))
            this.$vs.loading.close()
            for (let i = 0; i < formatted_desg.length; i++) {
              this.designations[i] = {'id': formatted_desg[i].id, 'label': formatted_desg[i].designationName}
            }
            return this.designations
          } else {
            this.$vs.loading.close()
            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.designations
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.designations
        })
    },
    formatUserPermissions (permissions) {
      const permText = []
      if (permissions.isAdmin == 1) { permText.push('Admin') }
      if (permissions.isNursingHomeAdmin == 1) { permText.push('Nursing Home Admin') }
      if (permissions.isStaff == 1) { permText.push('Staff Member') }
      if (permissions.isUser == 1) { permText.push('Customer') }

      return 	permText.join(', ')
    },
    viewAddUserdialog () {
      this.activeAddView = true
    },
    addNewUser () {
      this.errorList = []
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.$vs.loading()
          const formData = new FormData()
          formData.append('firstName', this.u_first_name)
          formData.append('lastName', this.u_last_name)
          formData.append('email', this.u_email)
          formData.append('password', this.u_password)
          formData.append('phone', this.u_phone)
          formData.append('designationID', this.u_role.id)
          formData.append('nursingHomeID', this.nursingHomeID)          
					
          this.$http.post('/create-user/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              this.$vs.loading.close()
              if (response.data.messageType == 'success') {
                this.$vs.notify({title:'Great!', text:'User added to Nursing Home.', color:'success', position:'top-right', icon:'check_box', time:5000})
                return location.reload()
                return this.staffList()
              } else {

                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return this.staffList()
              }

            })
            .catch((error)   => {
              console.log(error)
              this.$vs.loading.close()
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.staffList()
            })
        } else {
          // form have errors
          this.activeAddView = true
          return false
        }
      })
    },
    confirmDeletion (custID) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Are you sure ?',
        text: 'You want to deactivate this user ?',
        accept: this.RemoveNursingHomeUser,
        acceptText: 'Deactivate',
        parameters: custID
      })
      return true
    },
    confirmActivation (custID) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Are you sure ?',
        text: 'You want to Activate this user ?',
        accept: this.ActivateNursingHomeUser,
        acceptText: 'Activate',
        parameters: custID
      })
      return true
    },		
    	RemoveNursingHomeUser (custID) {
      console.log(custID)
      //return false;
      this.$vs.loading()
      this.$http.delete('/create-user/', {data: { nursingHomeID: this.nursingHomeID, custID, isActive: 0} })
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:'User deactivated successfully.', color:'success', position:'top-right', icon:'check_box', time:5000})
            return this.staffList()
          } else {

            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.staffList()
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.staffList()
        })
    },
    	ActivateNursingHomeUser (custID) {
      console.log(custID)
      //return false;
      this.$vs.loading()
      this.$http.delete('/create-user/', {data: { nursingHomeID: this.nursingHomeID, custID, isActive: 1} })
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.messageType == 'success') {
            this.$vs.notify({title:'Great!', text:'User activated successfully.', color:'success', position:'top-right', icon:'check_box', time:5000})
            return this.staffList()
          } else {

            this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
            return this.staffList()
          }

        })
        .catch((error)   => {
          console.log(error)
          this.$vs.loading.close()
          this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
          return this.staffList()
        })
    },		
    viewUserDetails (member) {
      this.up_first_name = member.firstName
      this.up_last_name = member.lastName
      this.up_phone = member.phone
      //this.up_role = member.designationID
      this.up_custID = member.custID
      this.activeDetailView = true

      for (let i = 0; i < this.designations.length; i++) {
        if (this.designations[i].id == member.designationID) {
          this.up_role = {'id': this.designations[i].id, 'label': this.designations[i].label}
        }
      }
    },
    updateUserInfo () {
      this.errorList = []
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.$vs.loading()
          const formData = new FormData()
          formData.append('firstName', this.up_first_name)
          formData.append('lastName', this.up_last_name)
          formData.append('phone', this.up_phone)
          formData.append('designationID', this.up_role.id)
          formData.append('nursingHomeID', this.nursingHomeID)
          formData.append('custID', this.up_custID)           
          this.$http.put('/create-user/', formData, { headers: {'Content-Type': 'multipart/form-data' }})
            .then((response) => {
              this.$vs.loading.close()
              if (response.data.messageType == 'success') {
                this.$vs.notify({title:'Great!', text:'User details updated.', color:'success', position:'top-right', icon:'check_box', time:5000})
                return this.staffList()
              } else {

                this.$vs.notify({title:'Attention!', text:response.data.message, color:'warning', position:'top-right', icon:'error', time:5000})
                return this.staffList()
              }

            })
            .catch((error)   => {
              console.log(error)
              this.$vs.loading.close()
              this.$vs.notify({title:'Something went wrong!', text:'Please try after some time.', color:'warning', position:'top-right', icon:'error', time:5000})
              return this.staffList()
            })
        } else {
          // form have errors
          this.activeDetailView = true
          return false
        }
      })

			
    }
			
  },
  created () {
    this.staffList()
    this.designationList()
  }
}
</script>
<style>
.profile-card{ float: left; padding: 0 10px; }
.card-btns button.vs-component.vs-button{ margin: 0 5px; padding: 0.5rem 0.8rem !important; }
button.vs-component.vs-button.vs-button-primary.vs-button-gradient {
    margin: 0 10px;
}
.cardx-holder .av-text-top span.mem-name {
    line-height: 60px;
    font-size: 18px;
    font-weight: 500;
    vertical-align: top;
}
.cardx-holder .mem-info-box{ margin: 5px 0; }
.cardx-holder .mem-info-box p{ font-size: 12px; }
.cardx-holder .mem-info-box p span{ font-size: 14px; font-weight: 500; color: rgba(var(--vs-primary), 1);}
.cardx-holder .av-text-top .feather-icon {
    vertical-align: top;
    padding: 0;
}
.top-row .add-btn-top { padding: 16px 16px !important; margin: 0 0 30px !important;}
.con-exemple-prompt {  padding: 10px; padding-bottom: 0px;}
.vs-input { width: 100%; margin-top: 10px; padding:0 10px; float: left;}
.con-vs-dialog .vs-dialog .vs-dialog-text { padding: 0 10px 15px; float: left;}
.vs-component.vs-con-input-label.vs-input.w-50.vs-input-primary {width: 50%;}
.con-exemple-prompt {float: left; padding: 0 5px;}
.con-exemple-prompt .section-upload .con-input-upload {width: 300px; height: 150px;}
.con-vs-dialog .vs-dialog .vs-dialog-text {
    float: left;
    width: 100%;
}
.con-vs-dialog .vs-dialog footer {
    padding: 1rem;
    float: left;
    width: 100%;
}
.con-select {
    width: 100%;
    clear: both;
    padding: 0px 10px;
}
.select-user-role .v-select{padding: 0 10px;}
</style>
